import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { Search } from 'lucide-react'
import HomeNavBar from '../HomeComponent/HomeNavBar'

const SearchBarSection = ({ allJob, setFilteredData }) => {
    let [searchWord, setSearchWord] = useState('')
    
    let searchFilter = () => {
        if (!allJob) return;
        let filteredData = allJob.filter((obj) => obj.Title &&
            obj.Title.toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
        setFilteredData(filteredData)
    }

    return (
        <div className='relative w-full bg-[#01014C] poppins min-h-[55vh] flex flex-col'>
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '32px 32px' }}></div>
            </div>
            
            <div className='relative z-10 w-full'>
                <HomeNavBar type='white' />
            </div>

            <main className='relative z-10 flex-1 flex flex-col justify-center items-center px-6 py-12'>
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center w-full max-w-3xl mx-auto"
                >
                    <span className="inline-block py-1 px-3 rounded-full bg-blue-500/20 text-blue-300 text-sm font-bold tracking-widest uppercase mb-6 border border-blue-400/30">
                        Join Our Team
                    </span>
                    <h1 className='text-white text-4xl sm:text-5xl md:text-6xl font-black mb-6 leading-tight'>
                        Find your <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-teal-300'>new job</span> today
                    </h1>
                    <p className='text-blue-100/80 text-lg md:text-xl mb-12 max-w-2xl mx-auto'>
                        Hundreds of jobs waiting for you. Discover your next career move with Merida HR.
                    </p>

                    {/* Modern Search Bar */}
                    <div className='bg-white/10 backdrop-blur-md border border-white/20 p-2 rounded-full flex items-center shadow-2xl mx-auto max-w-2xl'>
                        <div className="pl-4 pr-2 text-blue-300">
                            <Search size={24} />
                        </div>
                        <input 
                            value={searchWord} 
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    searchFilter()
                                }
                            }}
                            onChange={(e) => setSearchWord(e.target.value)}
                            type="text" 
                            className='flex-1 bg-transparent border-none outline-none text-white placeholder-blue-200/60 px-2 py-3 text-lg'
                            placeholder='What position are you looking for?' 
                        />
                        <button 
                            onClick={searchFilter} 
                            className='bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-400 hover:to-blue-500 text-white font-bold py-3 px-8 rounded-full transition-all duration-300 shadow-lg shadow-blue-500/30'
                        >
                            Search
                        </button>
                    </div>
                </motion.div>
            </main>
        </div>
    )
}

export default SearchBarSection